import { getErrorPayload } from '@application/helpers/api-helper';
import CompanyApi from '@infrastructure/company-api';
import { createAsyncThunk } from '@reduxjs/toolkit';
export const getAllUserCompaniesAsync = createAsyncThunk('company/getAll', async (_, { rejectWithValue }) => {
    try {
        const response = await CompanyApi.getAllUserCompaniesApi();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllCompaniesAsync = createAsyncThunk('company/getAllCompanies', async (_, { rejectWithValue }) => {
    try {
        const response = await CompanyApi.getAllCompaniesApi();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateCompanyAsync = createAsyncThunk('company/update', async (dto, { rejectWithValue }) => {
    try {
        const response = await CompanyApi.updateCompanyApi(dto);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteCompanyAsync = createAsyncThunk('company/delete', async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await CompanyApi.deleteCompanyApi(id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
